import React from 'react'

import Logo from '../../assets/images/Loader.gif'
import './pageoverlay.css'


const PageOverlayBusy = () => {
  return (
    <div className='loader' id='pageoverlay'>
      <div className='innerloader'>

        <p aria-label='Working on it' tabIndex={0} >Working on it</p>
        <img
          
          alt='Loader'
          aria-label='loader'
          className='waiting-dot'
          src={Logo}

        />
      </div>
    </div>
  )
}

export default PageOverlayBusy
